// extracted by mini-css-extract-plugin
export default {"div-results":"SectionResults_div-results__KXY3e","results-container":"SectionResults_results-container__CQx2o","buttons-container":"SectionResults_buttons-container__9+lb2"};